import { DecisionDetail } from "../../../models/home";
import { buildAction, buildConfidence, buildPriority, buildRisk, isoFromNow } from "./home-qa-harness.builders";

export const EXECUTABLE_DETAIL: DecisionDetail = {
  decision: {
    decisionId: "detail-ready",
    state: "act_now",
    title: "Approve supplier invoice for payment",
    shortReason: "The invoice is ready to be posted before the deadline.",
    documents: [
      {
        documentId: "doc-detail-ready",
        classificationId: "class-detail-ready",
        title: "Supplier invoice packet"
      }
    ],
    nextBestAction: buildAction("process_invoice", "Process invoice", true, {
      description: "Send the approved invoice to the ERP posting workflow.",
      completionCriteria: ["Confirm supplier", "Validate invoice code", "Post transaction"]
    }),
    availableActions: [
      buildAction("process_invoice", "Process invoice", true, {
        placement: "primary",
        riskLevel: "low",
        executionMode: "direct",
        description: "Send the approved invoice to the ERP posting workflow.",
        completionCriteria: ["Confirm supplier", "Validate invoice code", "Post transaction"]
      })
    ],
    priority: buildPriority(94, "critical", "A finance cutoff happens this afternoon."),
    risk: buildRisk("high", "Late posting creates reconciliation noise and supplier delays."),
    confidence: buildConfidence(0.95),
    evidence: [
      {
        evidenceId: "evidence-ready-1",
        type: "date",
        label: "Payment deadline",
        value: isoFromNow(8),
        confidence: 0.98,
        source: "invoice-extractor",
        occurredAt: isoFromNow(-1)
      }
    ],
    missingInformation: [],
    owner: { userId: "u-1", displayName: "Finance Ops" },
    dueAt: isoFromNow(8),
    updatedAt: isoFromNow(-1),
    traceId: "detail-ready-trace",
    sourceTrace: {
      traceId: "detail-ready-trace",
      actionSource: "policy-engine",
      confidenceSource: "invoice-classifier",
      explanationSource: "rule-evaluator",
      evaluatorVersion: "2026.05.10",
      rulesVersion: "home-ia-v3"
    }
  },
  activityPreview: [
    {
      eventId: "activity-ready-1",
      decisionId: "detail-ready",
      documentIds: ["doc-detail-ready"],
      type: "decision.updated",
      title: "Decision prioritized",
      narrative: "The priority score increased after the billing cutoff moved forward.",
      occurredAt: isoFromNow(-3)
    }
  ],
  relatedDecisionIds: ["detail-blocked"]
};
